export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtAQMAAAAUQe44AAAAA1BMVEX/7+P5B1XWAAAADklEQVQoz2MYBaOAGgAAAkkAAQmr4rUAAAAASUVORK5CYII="